<template>
  <div class="china-chart-box">
    <div class="chinesechart-cla" id="chinesechart"></div>
    <div class="showCurrent-cla">{{ currentItem }}</div>
    <numberScroll class="numberScroll-cla"></numberScroll>
    <div class="map-title-cla">
      <img class="imgicon" src="../../../assets/chart/ic_equipment.svg" />
      <span>实时在线设备</span>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import 'echarts-gl'
import { getData, getShowData } from './geoCoordMap.js'
import { getOption } from './chinaOption.js'
import numberScroll from './numberScroll'
let chinaJson = require('@/map/json/china.json')
echarts.registerMap('china', chinaJson)

export default {
  data() {
    return {
      myChart: null,
      charPie3currentIndex: 0, // 当前高亮索引值
      startCharts: null,
      data: [],
      currentItem: {},
      showIndex: 0
    }
  },
  components: {
    numberScroll
  },
  mounted() {
    var dom = document.getElementById('chinesechart')
    this.myChart = echarts.init(dom)
    this.data = getData()
    this.initChart()
  },
  beforeDestroy() {
    this.myChart.clear()
  },
  methods: {
    initChart() {
      this.startCharts = setInterval(() => {
        this.showIndex++
        if (this.showIndex > this.data.length) {
          this.showIndex = 0
        }
        let showData = getShowData(
          JSON.parse(JSON.stringify(this.data)),
          this.showIndex
        )
        if (showData.length === 2) {
          this.currentItem = showData[1]
        }
        this.myChart.setOption(getOption(showData), true, true)
      }, 2000)
    }
  }
}
</script>
<style scoped lang="less">
.china-chart-box {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 1405px;
  height: 1200px;
  position: relative;
}
.chinesechart-cla {
  position: absolute;
  height: 100%;
  width: 100%;
}
.showCurrent-cla {
  position: absolute;
  left: 50px;
  bottom: 150px;
  color: #53d4e2;
  z-index: 1000;
  font-size: 40px;
}
.numberScroll-cla {
  position: absolute;
  left: 450px;
  top: 110px;
  width: 600px;
  text-align: center;
}

.map-title-cla {
  height: 52px;
  line-height: 52px;
  position: absolute;
  left: 600px;
  top: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    )
    1 1;
  span {
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #c1cfe6;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.8);
  }
  .imgicon {
    width: 25px;
    height: 35px;
    margin-right: 10px;
    position: relative;
    top: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/china/chinaChar.vue